export const ErrorTypes = {
  BODY_ERROR: 'body',
  CATEGORY_ERROR: 'category',
  SLUG_ERROR: 'slug',
  TITLE_ERROR: 'title',
  CATEGORY_TRANSLATION: 'categoryTranslation',
  SUBCATEGORY_TRANSLATION: 'subcategoryTranslation',
  VARIANT_CATEGORY_TRANSLATION: 'variantCategoryTranslation',
  VARIANT_SUBCATEGORY_TRANSLATION: 'variantSubcategoryTranslation',
  NO_LIST_SELECTED_ERROR: 'noListSelected',
  NO_ACCESS_GROUP_SELECTED_ERROR: 'noAccessGroupSelected',
  ARTICLE_LANGUAGE_NOT_SUPPORTED_BY_KNOWLEDGE_BASE: 'articleLanguage',
  ARTICLE_IS_PUBLIC_IN_PRIVATE_KNOWLEDGE_BASE: 'publicArticlePrivateKB'
};
export const WarningTypes = {
  ESCAPE_HUBL_WARNING: 'escapeHublWarning'
};
export const CATEGORIZE_STEP_ERRORS = [ErrorTypes.SLUG_ERROR, ErrorTypes.CATEGORY_ERROR, ErrorTypes.CATEGORY_TRANSLATION, ErrorTypes.SUBCATEGORY_TRANSLATION, ErrorTypes.VARIANT_CATEGORY_TRANSLATION, ErrorTypes.VARIANT_SUBCATEGORY_TRANSLATION, ErrorTypes.NO_LIST_SELECTED_ERROR, ErrorTypes.NO_ACCESS_GROUP_SELECTED_ERROR, ErrorTypes.ARTICLE_LANGUAGE_NOT_SUPPORTED_BY_KNOWLEDGE_BASE, ErrorTypes.ARTICLE_IS_PUBLIC_IN_PRIVATE_KNOWLEDGE_BASE];
export const WRITE_STEP_ERRORS = [ErrorTypes.TITLE_ERROR, ErrorTypes.BODY_ERROR];